module.exports = __webpack_public_path__ + "d33bfe612c008a01f156d9a3a8a83027.svg";